import styled from "styled-components";

import CountriesSelectionModal from "app/pages/sales-intelligence/sub-modules/advanced-search/components/shared/CountriesSelectionModal/CountriesSelectionModal";

export const StyledCountriesSelectionModal = styled(CountriesSelectionModal)`
    min-height: 416px;
`;
